import React, { useEffect, useState } from "react";
import { clsx } from "clsx";

export const ProductTileQuickAdd = ({product, isHovered}) => {
  const [currentVariant, setCurrentVariant] = useState(null);
  const variantFirstId = product?.variants[0]?.id || product.id;

  useEffect(() => {
    if (!isHovered) {
      setCurrentVariant(null);
    }

    if (isHovered && product.variants.length <= 1) {
      setCurrentVariant(product.variants[0]);
    }
  }, [isHovered]);

  const updateCurrentVariant = (variant) => {
    setCurrentVariant(variant);
  };

  return (
    <>
      {product?.variants.length > 1 ? (
        <div
          className={clsx(
            "transition-all duration-300 w-full h-[42px] bottom-0 absolute cursor-default",
            {
              "max-h-0 opacity-0": !isHovered,
              "max-h-96 opacity-100 product-tile-hovered": isHovered,
            }
          )}
          onClick={(e) => e.stopPropagation()}
        >
          {!currentVariant && (
            <div
              className="productcard__quick-add"
              style={{ background: "rgba(255, 255, 255, 0.40)" }}
            >
              {product?.variants?.map((variant) => (
                <React.Fragment key={variant.id}>
                  {variant.available ? (
                    <button
                      className="flex b__quick_option cursor-pointer"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        updateCurrentVariant(variant);
                      }}
                    >
                      {variant.option1 || variant.options[0]}
                    </button>
                  ) : (
                    <div
                      className="flex b__quick_option text-black/20 cursor-default"
                    >
                      {variant.option1 || variant.options[0]}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {currentVariant && isHovered && (
            <ajax-cart-product-form class="flex w-full space-x-[28px] justify-center h-[42px] items-center bg-white">
              <form
                action="/cart/add"
                id="product_form_id"
                className="product-form w-full"
                noValidate
                data-prodify-product-form
              >
                <div className="flex w-full space-x-6 justify-center h5">
                  <div className="flex">
                    <p className="uppercase">Size&nbsp;:&nbsp;{currentVariant.option1 || currentVariant.options[0]}&nbsp;</p>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        updateCurrentVariant(null);
                      }}
                      className={"underline"}>CHANGE
                    </button>
                  </div>
                  <div className="text-black/20">|</div>
                  <input type="hidden" name="id" value={`${currentVariant.id}`} />
                  <button
                    type="submit"
                    className={""}
                    onClick={(e) => e.stopPropagation()}
                  >
                      ADD TO BAG
                  </button>
                </div>

                <div
                  data-ajax-cart-errors="form"
                  className="text-xs text-error-1 mt-2"
                ></div>
              </form>
            </ajax-cart-product-form>
          )}
        </div>
      ) : (
        <div
          className={clsx(
            "transition-all duration-300 w-full h-[42px] bottom-0 absolute cursor-default",
            {
              "max-h-0 opacity-0": !isHovered,
              "max-h-96 opacity-100 product-tile-hovered": isHovered,
            }
          )}
          onClick={(e) => e.stopPropagation()}
        >
          {currentVariant && (
            <ajax-cart-product-form class="flex w-full space-x-[28px] justify-center h-[42px] items-center bg-white">
              <form
                action="/cart/add"
                id="product_form_id"
                className="product-form w-full"
                noValidate
                data-prodify-product-form
              >
                <div className="flex w-full justify-center h5">
                  <input type="hidden" name="id" value={`${currentVariant.id}`} />
                  <button
                    type="submit"
                    className={""}
                    onClick={(e) => e.stopPropagation()}
                    >
                      ADD TO BAG
                  </button>
                </div>

                <div
                  data-ajax-cart-errors="form"
                  className="text-xs text-error-1 mt-2"
                ></div>
              </form>
            </ajax-cart-product-form>
          )}
        </div>
      )}
    </>
  );
}

export default ProductTileQuickAdd;
